<template>
  <div class="return-pay-fee-manage-container animated fadeInRight">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('returnPayFeeManage.search.title') }}</span>
        <div class="card-header-tools">
          <el-button type="text" @click="_moreCondition" style="padding:0px">
            {{ returnPayFeeManageInfo.moreCondition ? $t('returnPayFeeManage.search.hide') : $t('returnPayFeeManage.search.more') }}
          </el-button>
        </div>
      </div>
      <el-form :model="returnPayFeeManageInfo.conditions" label-width="0">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="returnPayFeeManageInfo.conditions.detailId"
                :placeholder="$t('returnPayFeeManage.search.detailId')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-select
                v-model="returnPayFeeManageInfo.conditions.orderType"
                :placeholder="$t('returnPayFeeManage.search.orderType')"
                style="width: 100%"
                clearable
              >
                <el-option value="" :label="$t('returnPayFeeManage.search.orderType')" />
                <el-option value="2002" label="缴费单" />
                <el-option value="3003" label="押金" />
                <el-option value="1001" label="预付收款" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="_queryReturnPayFeeMethod">
                {{ $t('returnPayFeeManage.search.query') }}
              </el-button>
              <el-button icon="el-icon-refresh" @click="_resetReturnPayFeeMethod">
                {{ $t('returnPayFeeManage.search.reset') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 更多查询条件 -->
        <div v-show="returnPayFeeManageInfo.moreCondition">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="returnPayFeeManageInfo.conditions.applyPersonName"
                  :placeholder="$t('returnPayFeeManage.search.applyPersonName')"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="returnPayFeeManageInfo.conditions.auditPersonName"
                  :placeholder="$t('returnPayFeeManage.search.auditPersonName')"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="returnPayFeeManageInfo.conditions.payerObjName"
                  :placeholder="$t('returnPayFeeManage.search.payerObjName')"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item>
                <el-date-picker
                  v-model="returnPayFeeManageInfo.conditions.startTime"
                  type="datetime"
                  :placeholder="$t('returnPayFeeManage.search.startTime')"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-date-picker
                  v-model="returnPayFeeManageInfo.conditions.endTime"
                  type="datetime"
                  :placeholder="$t('returnPayFeeManage.search.endTime')"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-card>

    <!-- 退费申请单列表 -->
    <el-card class="list-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('returnPayFeeManage.list.title') }}</span>
        <div class="card-header-tools">
          <el-button type="primary" size="small" @click="_exportFee">
            {{ $t('returnPayFeeManage.list.export') }}
          </el-button>
        </div>
      </div>

      <!-- 状态统计 Tab -->
      <el-tabs v-model="activeTab" class="state-tabs" @tab-click="_handleTabClick">
        <el-tab-pane
          v-for="tab in returnPayFeeManageInfo.tabs"
          :key="tab.name"
          :name="tab.name"
        >
          <span slot="label">
            {{ $t('returnPayFeeManage.tabs.' + tab.i18n) }}
            <span :class="['tab-count', { 'tab-count-danger': tab.danger }]">{{ tabCounts[tab.name] }}</span>
          </span>
        </el-tab-pane>
      </el-tabs>

      <el-table
        v-loading="loading"
        :data="returnPayFeeManageInfo.returnPayFees"
        border
        style="width: 100%"
      >
        <el-table-column prop="refundOrderId" :label="$t('returnPayFeeManage.table.refundOrderId')" align="center" />
        <el-table-column :label="$t('returnPayFeeManage.table.orderType')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.orderType === '2002'">退缴费单</span>
            <span v-else-if="scope.row.orderType === '3003'">退押金</span>
            <span v-else>退预付单</span>
          </template>
        </el-table-column>
        <el-table-column prop="payerObjName" :label="$t('returnPayFeeManage.table.payerObjName')" align="center" />
        <el-table-column prop="ownerName" :label="$t('returnPayFeeManage.table.ownerName')" align="center" />
        <el-table-column :label="$t('returnPayFeeManage.table.feeName')" align="center">
          <template slot-scope="scope">
            <div v-for="detail in scope.row.details" :key="detail.feeName" style="width: 110px;">
              {{ detail.feeName }}<br>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('returnPayFeeManage.table.timeRange')" align="center">
          <template slot-scope="scope">
            <div v-for="detail in scope.row.details" :key="detail.startTime" style="width: 180px;">
              {{ dateFormat(detail.startTime) }}~{{ dateFormat(detail.endTime) }}<br>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('returnPayFeeManage.table.amount')" align="center">
          <template slot-scope="scope">
            <div v-for="detail in scope.row.details" :key="detail.receivedAmount">
              {{ detail.receivedAmount }}<br>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('returnPayFeeManage.table.createTime')" align="center" />
        <el-table-column prop="reason" :label="$t('returnPayFeeManage.table.reason')" align="center" />
        <el-table-column :label="$t('returnPayFeeManage.table.applyPersonName')" align="center">
          <template slot-scope="scope">
            {{ scope.row.applyPersonName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('returnPayFeeManage.table.state')" align="center">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.state === '1000'"
              type="info"
            >{{ $t('returnPayFeeManage.state.waitAudit') }}</el-tag>
            <el-tag
              v-else-if="scope.row.state === '1100' && scope.row.refundState === 'FT'"
              type="danger"
            >{{ $t('returnPayFeeManage.state.refundFail') }}</el-tag>
            <el-tag
              v-else-if="scope.row.state === '1100' && scope.row.refundState === 'WT'"
              type="warning"
            >{{ $t('returnPayFeeManage.state.refunding') }}</el-tag>
            <el-tag
              v-else-if="scope.row.state === '1100' && scope.row.refundState === 'CT'"
              type="success"
            >{{ $t('returnPayFeeManage.state.refundDone') }}</el-tag>
            <el-tag
              v-else-if="scope.row.state === '1100'"
              type="warning"
            >{{ $t('returnPayFeeManage.state.waitRefund') }}</el-tag>
            <el-tag
              v-else-if="scope.row.state === '1200'"
              type="danger"
            >{{ $t('returnPayFeeManage.state.reject') }}</el-tag>
            <el-tag
              v-else
              type="info"
            >{{ scope.row.stateName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('returnPayFeeManage.table.auditPersonName')" align="center">
          <template slot-scope="scope">
            {{ scope.row.auditPersonName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('returnPayFeeManage.table.refundRemark')" align="center">
          <template slot-scope="scope">
            <div class="hc-td">{{ scope.row.refundRemark || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('returnPayFeeManage.table.operation')" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                v-if="scope.row.state === '1000'"
                size="mini"
                type="primary"
                @click="_openReturnPayFeeAuditModel(scope.row)"
              >
                {{ $t('returnPayFeeManage.table.audit') }}
              </el-button>
              <el-button
                v-if="scope.row.state === '1100' && scope.row.refundState !== 'CT'"
                size="mini"
                type="warning"
                @click="_tryRefundMoney(scope.row)"
              >
                {{ scope.row.refundState === 'FT' ? $t('returnPayFeeManage.table.retryRefund') : $t('returnPayFeeManage.table.startRefund') }}
              </el-button>
              <!-- <el-button
                size="mini"
                @click="_toReturnFeeDetail(scope.row)"
              >
                {{ $t('returnPayFeeManage.table.detail') }}
              </el-button> -->
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 审核组件 -->
    <audit-component
      ref="auditComponent"
      @notifyAuditInfo="notifyAuditInfo"
    />
  </div>
</template>

<script>
import { listReturnPayFees, updateReturnPayFee, auditRefundPrePayFee, auditRefundDeposit, tryRefundMoney } from '@/api/fee/returnPayFeeManageApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import AuditComponent from '@/components/fee/audit'
import { dateFormat } from '@/utils/dateUtil'

export default {
  name: 'ReturnPayFeeManageList',
  components: {
    AuditComponent
  },
  data() {
    return {
      loading: false,
      // 默认停留在 待审核 Tab
      activeTab: '1000',
      tabCounts: {
        '1000': 0,
        refunding: 0,
        refundFail: 0,
        refundDone: 0,
        '1200': 0,
        all: 0
      },
      returnPayFeeManageInfo: {
        returnPayFees: [],
        moreCondition: false,
        feeTypes: [],
        // 各 Tab 对应的查询条件，与 tabCounts 一一对应
        tabs: [
          { name: '1000', i18n: 'waitAudit', state: '1000', refundState: '', refundStateNotIn: '', danger: false },
          // 退款中改为仅统计线上退款在途(WT)的单：原条件 refundStateNotIn:'FT,CT'（not exists）
          // 会把线下现金/POS/转账退款（无线上退款记录、审核通过即完成）永久计入"退款中"
          // { name: 'refunding', i18n: 'refunding', state: '1100', refundState: '', refundStateNotIn: 'FT,CT', danger: false },
          { name: 'refunding', i18n: 'refunding', state: '1100', refundState: 'WT', refundStateNotIn: '', danger: false },
          { name: 'refundFail', i18n: 'refundFail', state: '1100', refundState: 'FT', refundStateNotIn: '', danger: true },
          // 退款完成改为 CT 或 线下退款（无任何线上退款记录，审核通过即线下完成），由后端 refundDoneIncludeOffline 条件实现
          // { name: 'refundDone', i18n: 'refundDone', state: '1100', refundState: 'CT', refundStateNotIn: '', danger: false },
          { name: 'refundDone', i18n: 'refundDone', state: '1100', refundState: '', refundStateNotIn: '', refundDoneIncludeOffline: 'Y', danger: false },
          { name: '1200', i18n: 'reject', state: '1200', refundState: '', refundStateNotIn: '', danger: false },
          { name: 'all', i18n: 'all', state: '', refundState: '', refundStateNotIn: '', danger: false }
        ],
        conditions: {
          communityId: '',
          detailId: '',
          state: '1000',
          refundState: '',
          refundStateNotIn: '',
          refundDoneIncludeOffline: '',
          orderType: '',
          payerObjName: '',
          startTime: '',
          endTime: '',
          auditPersonName: '',
          applyPersonName: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      this.returnPayFeeManageInfo.conditions.communityId = getCommunityId()
      this._listReturnPayFees(this.page.current, this.page.size)
      this._countReturnPayFees()

      try {
        const feeTypes = await getDict('pay_fee_config', 'fee_type_cd')
        this.returnPayFeeManageInfo.feeTypes = feeTypes
      } catch (error) {
        console.error('获取费用类型字典失败:', error)
      }
    },

    _buildQueryParams(currentPage, pageSize) {
      const conditions = this.returnPayFeeManageInfo.conditions
      const params = {
        ...conditions,
        page: currentPage,
        row: pageSize
      }

      // 去除参数中的空格
      if (params.detailId) params.detailId = params.detailId.trim()
      if (params.payerObjName) params.payerObjName = params.payerObjName.trim()
      if (params.applyPersonName) params.applyPersonName = params.applyPersonName.trim()
      if (params.auditPersonName) params.auditPersonName = params.auditPersonName.trim()

      return params
    },

    async _listReturnPayFees(currentPage, pageSize) {
      try {
        this.loading = true
        const res = await listReturnPayFees(this._buildQueryParams(currentPage, pageSize))
        if (res.code !== 0) {
          this.$message.error(res.msg || this.$t('returnPayFeeManage.fetchError'))
          return
        }
        this.returnPayFeeManageInfo.returnPayFees = res.data
        this.page.total = res.total
      } catch (error) {
        this.$message.error(this._resolveErrMsg(error, this.$t('returnPayFeeManage.fetchError')))
      } finally {
        this.loading = false
      }
    },

    /**
     * 并行查询各 Tab 的数量统计（page=1&row=1 只取 total）
     */
    async _countReturnPayFees() {
      const tasks = this.returnPayFeeManageInfo.tabs.map(tab => {
        const params = {
          ...this._buildQueryParams(1, 1),
          state: tab.state,
          refundState: tab.refundState,
          refundStateNotIn: tab.refundStateNotIn,
          refundDoneIncludeOffline: tab.refundDoneIncludeOffline || ''
        }
        return listReturnPayFees(params)
          .then(res => ({ name: tab.name, count: res.code === 0 ? (res.total || 0) : 0 }))
          .catch(() => ({ name: tab.name, count: 0 }))
      })
      const results = await Promise.all(tasks)
      results.forEach(item => {
        this.tabCounts[item.name] = item.count
      })
    },

    _handleTabClick(tab) {
      const tabConfig = this.returnPayFeeManageInfo.tabs.find(item => item.name === tab.name)
      if (!tabConfig) return
      this.returnPayFeeManageInfo.conditions.state = tabConfig.state
      this.returnPayFeeManageInfo.conditions.refundState = tabConfig.refundState
      this.returnPayFeeManageInfo.conditions.refundStateNotIn = tabConfig.refundStateNotIn
      this.returnPayFeeManageInfo.conditions.refundDoneIncludeOffline = tabConfig.refundDoneIncludeOffline || ''
      this.page.current = 1
      this._listReturnPayFees(this.page.current, this.page.size)
    },

    _queryReturnPayFeeMethod() {
      this.page.current = 1
      this._listReturnPayFees(this.page.current, this.page.size)
      this._countReturnPayFees()
    },

    _resetReturnPayFeeMethod() {
      this.returnPayFeeManageInfo.conditions = {
        communityId: getCommunityId(),
        detailId: '',
        feeTypeCd: '',
        state: '',
        refundState: '',
        refundStateNotIn: '',
        refundDoneIncludeOffline: '',
        orderType: '',
        payerObjName: '',
        startTime: '',
        endTime: '',
        applyPersonName: '',
        auditPersonName: ''
      }
      this.activeTab = 'all'
      this._listReturnPayFees(1, this.page.size)
      this._countReturnPayFees()
    },

    async notifyAuditInfo(auditInfo) {
      const refundFee = this.returnPayFeeManageInfo.returnPayFee
      if (!refundFee) return

      refundFee.state = auditInfo.state
      refundFee.payableAmount = 0.0

      try {
        if (refundFee.orderType === '2002') {
          await this._auditReturnPayFeeState(auditInfo)
        } else if (refundFee.orderType === '3003') {
          await this._auditRefundDepositState(auditInfo)
        } else {
          await this._auditRefundPrePayFeeState(auditInfo)
        }
      } catch (error) {
        this.$message.error(this._resolveErrMsg(error, this.$t('returnPayFeeManage.auditError')))
      }
    },

    async _auditRefundPrePayFeeState(auditInfo) {
      const returnPayFee = { ...this.returnPayFeeManageInfo.returnPayFee }
      returnPayFee.state = auditInfo.state
      returnPayFee.payableAmount = 0.0

      const res = await auditRefundPrePayFee(returnPayFee)
      if (res.code !== 0) {
        this.$message.error(res.msg || this.$t('returnPayFeeManage.auditError'))
        return
      }
      this.$message.success(this.$t('returnPayFeeManage.auditSuccess'))
      this._refreshListAndCounts()
    },

    async _auditReturnPayFeeState(auditInfo) {
      const returnPayFee = { ...this.returnPayFeeManageInfo.returnPayFee }
      returnPayFee.state = auditInfo.state
      returnPayFee.payableAmount = 0.0

      const res = await updateReturnPayFee(returnPayFee)
      if (res.code !== 0) {
        this.$message.error(res.msg || this.$t('returnPayFeeManage.auditError'))
        return
      }
      this.$message.success(this.$t('returnPayFeeManage.auditSuccess'))
      this._refreshListAndCounts()
    },

    async _auditRefundDepositState(auditInfo) {
      const returnPayFee = { ...this.returnPayFeeManageInfo.returnPayFee }
      returnPayFee.state = auditInfo.state
      returnPayFee.payableAmount = 0.0

      const res = await auditRefundDeposit(returnPayFee)
      if (res.code !== 0) {
        this.$message.error(res.msg || this.$t('returnPayFeeManage.auditError'))
        return
      }
      this.$message.success(this.$t('returnPayFeeManage.auditSuccess'))
      this._refreshListAndCounts()
    },

    async _tryRefundMoney(rPayFee) {
      try {
        const params = {
          refundOrderId: rPayFee.refundOrderId,
          communityId: getCommunityId()
        }
        const res = await tryRefundMoney(params)
        if (res.code !== 0) {
          this.$message.error(res.msg || this.$t('returnPayFeeManage.refundError'))
          return
        }
        // 退款为异步处理，提交成功后需刷新查看结果
        this.$message.success(this.$t('returnPayFeeManage.refundProcessing'))
        this._refreshListAndCounts()
      } catch (error) {
        this.$message.error(this._resolveErrMsg(error, this.$t('returnPayFeeManage.refundError')))
      }
    },

    _refreshListAndCounts() {
      this._listReturnPayFees(this.page.current, this.page.size)
      this._countReturnPayFees()
    },

    _resolveErrMsg(error, fallback) {
      const data = error && error.response && error.response.data
      if (data) {
        if (typeof data === 'string' && data) return data
        if (data.msg) return data.msg
      }
      return fallback
    },

    _moreCondition() {
      this.returnPayFeeManageInfo.moreCondition = !this.returnPayFeeManageInfo.moreCondition
    },

    _exportFee() {
      const params = new URLSearchParams(this.returnPayFeeManageInfo.conditions).toString()
      window.open(`/callComponent/exportReportFee/exportData?pagePath=returnPayFeeManage&${params}`, '_blank')
    },

    _openReturnPayFeeAuditModel(payFee) {
      this.returnPayFeeManageInfo.returnPayFee = payFee
      this.$refs.auditComponent.open()
    },

    // _toReturnFeeDetail(payFee) {
    //   this.$router.push(`/views/fee/propertyFee?feeId=${payFee.feeId}`)
    // },

    handleSizeChange(val) {
      this.page.size = val
      this._listReturnPayFees(this.page.current, this.page.size)
    },

    handleCurrentChange(val) {
      this.page.current = val
      this._listReturnPayFees(this.page.current, this.page.size)
    },

    dateFormat,
  }
}
</script>

<style lang="scss" scoped>
.return-pay-fee-manage-container {
  padding: 20px;

  .search-card, .list-card {
    margin-bottom: 20px;
  }

  .card-header-tools {
    float: right;
  }

  .state-tabs {
    margin-bottom: 15px;

    .tab-count {
      margin-left: 4px;
      color: #909399;

      &.tab-count-danger {
        color: #f56c6c;
        font-weight: 600;
      }
    }
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }

  .hc-td {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
